"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.safeStringify = exports.isDraft = exports.getQueryParam = exports.get = exports.clone = void 0;

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Cyclic_object_value
const getCircularReplacer = () => {
  const seen = new WeakSet();
  return (_, value) => {
    if (typeof value === 'object' && value !== null) {
      if (seen.has(value)) {
        return;
      }

      seen.add(value);
    }

    return value;
  };
};

const safeStringify = jsonObj => JSON.stringify(jsonObj, getCircularReplacer());

exports.safeStringify = safeStringify;

const get = (object, path, defaultValue) => {
  if (!object) {
    return typeof defaultValue !== 'undefined' ? defaultValue : object;
  }

  let internalObject = object;
  const seg = path.indexOf('.') !== -1 ? path.split('.') : [path];

  while (internalObject && seg.length) {
    internalObject = internalObject[seg.shift().replace(/[\[\]']+/g, '')];
  }

  return internalObject !== undefined ? internalObject : defaultValue;
};

exports.get = get;

const getQueryParam = (out, queryParam) => {
  if (typeof window === 'object') {
    return new URL(window.location.href).searchParams.get(queryParam);
  }

  return get(out, `global.req.query.${queryParam}`);
};

exports.getQueryParam = getQueryParam;

const isDraft = out => getQueryParam(out, 'draft') === 'true';

exports.isDraft = isDraft;

const clone = model => JSON.parse(JSON.stringify(model));

exports.clone = clone;